import React, { useState, useEffect } from "react";
import LocalStorageContext from "../Context/LocalStorageContext";

const LocalStorageProvider: React.FC<any> = ({ children }) => {
	const [logoSrc, setLogoSrc] = useState(() => {
		const item = sessionStorage.getItem("PartnerLogo");
		return item ? item : null;
	});

	const [status, setStatus] = useState(() => {
		const onboardingstatus = sessionStorage.getItem("OnboardingStatus");
		return onboardingstatus ? onboardingstatus : null;
	});

	const [stepflag, setStepFlag] = useState(() => {
		const step = sessionStorage.getItem("StepFlag");
		return step ? step : null;
	});

	const [facilitator, setFacilitator] = useState(() => {
		const isfacilitator = sessionStorage.getItem("IsFacilitator");
		return isfacilitator ? isfacilitator : null;
	});

	const [role, setRole] = useState(() => {
		const partnerrole = sessionStorage.getItem("PartnerPaymentRole");
		return partnerrole ? partnerrole : null;
	});

	useEffect(() => {
		if (logoSrc) sessionStorage.setItem("PartnerLogo", logoSrc);
	}, [logoSrc]);

	useEffect(() => {
		if (status != null) sessionStorage.setItem("OnboardingStatus", status);
	}, [status]);

	useEffect(() => {
		if (stepflag != null) sessionStorage.setItem("StepFlag", stepflag);
	}, [stepflag]);

	useEffect(() => {
		if (facilitator != null) sessionStorage.setItem("IsFacilitator", facilitator);
	}, [facilitator]);

	useEffect(() => {
		if (role != null) sessionStorage.setItem("PartnerPaymentRole", role);
	}, [role]);

	const updateLogoSrc = (newLogoSrc: any) => {
		setLogoSrc(newLogoSrc);
	};

	const updateStatus = (newStatus: any) => {
		setStatus(newStatus);
	};

	const updateStepFlag = (newStep: any) => {
		setStepFlag(newStep);
	};

	const updateFacilitator = (facilitator: any) => {
		setFacilitator(facilitator);
	};

	const updateRole = (role: any) => {
		setRole(role);
	};

	return (
		<LocalStorageContext.Provider
			value={{ logoSrc, updateLogoSrc, status, updateStatus, stepflag, updateStepFlag, facilitator, updateFacilitator, role, updateRole }}
		>
			{children}
		</LocalStorageContext.Provider>
	);
};

export default LocalStorageProvider;
